

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['isMobole', 'currentPage']),
  watch: {
    // currentPage(newValue, oldValue) {
    //   if(newValue === 'Selected'){
    //     this.onType()
    //   }
    //   console.log('新值:', newValue);
    // },
  },
})
export default class Menu extends Vue {
  isMobole!: Boolean;

  type = false;
  type2 = false;
  menu1 = [
    {
      name: '隔热隔晒',
      page: 'Insulation',
    },
    {
      name: '清晰防眩光',
      page: 'Dazzle',
    },
    {
      name: '信号无干扰',
      page: 'Signal',
    },
    {
      name: '绿色环保材质',
      page: 'Environment',
    },
    {
      name: '超长质保',
      page: 'Warranty',
    },
  ];
  menu2 = [
    {
      name: '精选系列',
      page: 'Selected',
    },
    {
      name: '尊享系列',
      page: 'Enjoy',
    },
    {
      name: '安全尊享系列',
      page: 'EnjoySafety',
    },
    {
      name: '全车安全系列',
      page: 'VehicleSafety',
    },
  ];

  mounted() {
    const self = this; // 保存组件实例的引用
    this.$watch('currentPage', function (newValue, oldValue) {
      if (newValue === 'Selected' && oldValue === 'Warranty') {
        this.type = false;
        this.type2 = true;
      }
      if (newValue === 'Warranty' && oldValue === 'Selected') {
        this.type = true;
        this.type2 = false;
      }
      if (newValue === 'Insulation' && oldValue === 'Home') {
        this.type = true;
        this.type2 = false;
      }
    });
  }
  pageRouter(i) {
    this.$store.commit('setCurrentPage', i);
    console.log(i);
  }

  onType() {
    this.type = !this.type;
    this.type2 = false;
  }
  onType2() {
    this.type2 = !this.type2;
    this.type = false;
  }
}
